import { render } from "./CenteredTextImageSection2.vue?vue&type=template&id=63b0ecbf&scoped=true"
import script from "./CenteredTextImageSection2.vue?vue&type=script&lang=js"
export * from "./CenteredTextImageSection2.vue?vue&type=script&lang=js"

import "./CenteredTextImageSection2.vue?vue&type=style&index=0&id=63b0ecbf&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.4.38_vue@3.2.13_webpack@5.94.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63b0ecbf"]])

export default __exports__